import { LAYOUT } from "../Action";

const intialState = {
  layout: {
    layoutLeft: true,
    jobRight: false,
  },
  pathName: "",
  signUp: {},
  anyChatOpen: false,
  localStorage: {},
};
const LayoutReducer = (state = intialState, action) => {
  switch (action.type) {
    case LAYOUT.minimizeIcon:
      return {
        ...state,
        layout: {
          layoutLeft: action.layoutLeft,
          jobRight: action.jobRight,
        },
      };
    case LAYOUT.pathName:
      return {
        ...state,
        pathName: action.data,
      };
    case LAYOUT.signUp:
      return {
        ...state,
        signUp: action.data,
      };
    case LAYOUT.anyChatOpen:
      return {
        ...state,
        anyChatOpen: action.data,
      };
    case LAYOUT.localStorage:
      return {
        ...state,
        localStorage: action.data?.data,
      };
    default:
      return state;
  }
};
export default LayoutReducer;
